module.exports = __webpack_public_path__ + "static/media/Marketing.3dfcb44b.svg";